import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUserDispatch, handleProfileSelection } from "../../context/UserContext";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Icon } from "@iconify/react";
import logo from "../../assets/images/logo.svg";
import loginBG from "../../assets/images/selectBG.png";

const AccountSelect = () => {
  const navigate = useNavigate();
  const userDispatch = useUserDispatch();
  const [profiles, setProfiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedSchool, setSelectedSchool] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null);
  const [currentStep, setCurrentStep] = useState(1);

  useEffect(() => {
    const storedProfiles = localStorage.getItem("multiple_profiles");
    if (!storedProfiles) {
      navigate("/auth/login");

      return;
    }
    try {
      const parsedProfiles = JSON.parse(storedProfiles);
      setProfiles(parsedProfiles);
    } catch (error) {
      navigate("/auth/login");
    }
  }, [navigate]);

  const renderRoleIcon = (roleName) => {
    const name = roleName?.toLowerCase() || "";
    if (name.includes("admin")) {
      return <Icon icon="mdi:shield-account" width="48" height="48" color="#0d6efd" />;
    }
    if (name.includes("staff") || name.includes("teacher")) {
      return <Icon icon="mdi:human-male-board" width="48" height="48" />;
    }
    if (name.includes("student")) {
      return <Icon icon="mdi:account-school" width="48" height="48" />;
    }
    if (name.includes("parent")) {
      return <Icon icon="mdi:account-child" width="48" height="48" />;
    }

    return <Icon icon="mdi:account-group" width="48" height="48" />;
  };

  const handleSchoolSelect = (school) => {
    setSelectedSchool(school);
    setSelectedRole(null);
    setCurrentStep(2);
  };

  const handleRoleSelect = async (role) => {
    if (isLoading) return;

    setSelectedRole(role);
    const profileId = role.id;

    if (!profileId) {
      toast.error("Invalid profile selection");

      return;
    }

    await handleProfileSelection(userDispatch, profileId, navigate, setIsLoading);
  };

  const handleBack = () => {
    setSelectedSchool(null);
    setSelectedRole(null);
    setCurrentStep(1);
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-container">
        <div className="auth-flex">
          <div className="auth-bg-container">
            <img src={loginBG} className="auth-bg-img" alt="Background" />
          </div>

          <div className="auth-form-container">
            <div className="auth-content">
              {currentStep === 1 && (
                <>
                  <div className="auth-logo-container">
                    <img src={logo} alt="Logo" className="auth-logo" />
                  </div>

                  <h2 className="auth-heading" style={{ margin: 0 }}>Choose your school</h2>
                  <p className="auth-subheading" style={{ margin: 0 }}>Select the school you want to access.</p>

                  <div className="selection-list">
                    {profiles.map((school) => (
                      <div
                        key={school.school_id}
                        className={`selection-card school-card ${selectedSchool?.school_id === school.school_id ? "active" : ""}`}
                        onClick={() => handleSchoolSelect(school)}
                      >
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <div className="card-icon-wrapper">
                            <Icon icon="solar:user-bold" width="24" height="24" />
                          </div>
                          <div className="card-info">
                            <h3>{school.school_name}</h3>
                          </div>
                        </div>
                        <div className="card-arrow">
                          <Icon icon="lsicon:arrow-right-filled" width="24" height="24" />
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              )}

              {currentStep === 2 && selectedSchool && (
                <>
                  <button className="back-link" onClick={handleBack}>
                    <Icon icon="quill:arrow-left" inline={true} width="28" height="28" />
                  </button>

                  <div className="auth-logo-container">
                    <img src={logo} alt="Logo" className="auth-logo" />
                  </div>

                  <h2 className="auth-heading" style={{ margin: 0 }}>Choose your role</h2>
                  <p className="auth-subheading" style={{ margin: 0 }}>
                    Select your role
                  </p>

                  <div className="role-grid">
                    {selectedSchool.roles.map((role) => (
                      <div
                        key={role.id}
                        className="role-card"
                        onClick={() => handleRoleSelect(role)}
                      >
                        <div className="card-content">
                          <div className="role-icon-wrapper">
                            {renderRoleIcon(role.role_name, selectedRole?.id === role.id)}
                          </div>
                          <span className="role-name">{role.role_name}</span>
                        </div>

                        <div className="role-arrow">
                          <Icon icon="mdi:arrow-right" width="20" height="20" />
                        </div>
                      </div>

                    ))}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountSelect;
